var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("form", { on: { submit: _vm.showExpenses } }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-3" },
              [
                _c("p", [_vm._v("Начало периода")]),
                _vm._v(" "),
                _c("DateSelect", {
                  ref: "start_date",
                  attrs: { selectedDate: _vm.periodDates.start },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-3" },
              [
                _c("p", [_vm._v("Конец периода")]),
                _vm._v(" "),
                _c("DateSelect", {
                  ref: "end_date",
                  attrs: { selectedDate: _vm.periodDates.end },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row p-t-10" }, [
            Object.keys(_vm.divisions).length
              ? _c("div", { staticClass: "col-md-9 division_select_list" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.showAllDivisions = !_vm.showAllDivisions
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.showAllDivisions
                              ? "Скрыть дивизионы"
                              : "Показать дивизионы"
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showAllDivisions
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex_gap_10 mb-1" },
                            [
                              _c(
                                "button",
                                {
                                  class: {
                                    btn: true,
                                    "btn-outline-primary": true,
                                    active: _vm.divisions[0].selected,
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.divisions[0].selected =
                                        !_vm.divisions[0].selected
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  Администрация\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.getSortedDivisions(
                                  Object.values(_vm.divisions),
                                  [1, 201]
                                ),
                                function (division, divId) {
                                  return _c(
                                    "div",
                                    [
                                      _c("DivisionBtn", {
                                        attrs: { division: division },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "m-2" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex_gap_10 flex-wrap" },
                            _vm._l(
                              _vm.getSortedDivisions(
                                Object.values(_vm.divisions),
                                null,
                                [1, 201]
                              ),
                              function (division, divId) {
                                return +division.id !== 0
                                  ? _c(
                                      "div",
                                      [
                                        _c("DivisionBtn", {
                                          attrs: { division: division },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "m-2" }),
                          _vm._v(" "),
                          _c("h5", [_vm._v("Не активные дивизионы")]),
                          _vm._v(" "),
                          _c("InActiveDivisionSelect", {
                            ref: "inActiveDivisions",
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", [
                _c(
                  "div",
                  [
                    _c(
                      "multiselect",
                      {
                        attrs: {
                          options: _vm.allExpensesTypesOptions,
                          "track-by": "title",
                          label: "title",
                          noResult: "Тип расхода не найден",
                          disabled: false,
                          "show-labels": false,
                          placeholder: "Выберите тип расхода",
                          multiple: true,
                        },
                        model: {
                          value: _vm.selectedExpenses,
                          callback: function ($$v) {
                            _vm.selectedExpenses = $$v
                          },
                          expression: "selectedExpenses",
                        },
                      },
                      [
                        _c("template", { slot: "noResult" }, [
                          _vm._v("Тип расхода не найден"),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "m-t-10" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "button",
                      {
                        class: {
                          "btn-sm": true,
                          btn: true,
                          "btn-outline-primary": true,
                          active: _vm.getGlobalCurrency,
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.getGlobalCurrency = !_vm.getGlobalCurrency
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    приводить к единой валюте\n                  "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedCurrency,
                            expression: "selectedCurrency",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedCurrency = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.$AllCurrencies, function (currency) {
                        return _c(
                          "option",
                          { domProps: { value: currency.id } },
                          [
                            _vm._v(
                              _vm._s(currency && currency.currency) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "m-t-10" },
                  [
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "btn btn-success",
                          "data-style": "zoom-in",
                          type: "submit",
                          loading: _vm.loading,
                        },
                      },
                      [_vm._v("Показать\n                ")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.summary && Object.keys(_vm.summary).length
                ? _c("div", { staticClass: "m-t-20 card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("h5", [_vm._v("Итого:")]),
                        _vm._v(" "),
                        _vm._l(_vm.summary, function (sum, curr) {
                          return curr !== "sum"
                            ? _c("p", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$AllCurrencies[curr].currency) +
                                    ": "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(sum.toLocaleString("ru-RU"))),
                                ]),
                              ])
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Всего " +
                              _vm._s(
                                _vm.$AllCurrencies[_vm.resultCurrency].currency
                              ) +
                              ": "
                          ),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.summary.sum.toLocaleString("ru-RU"))
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _vm.loading
            ? _c("pulse-loader", {
                staticClass: "text-center",
                attrs: { loading: _vm.loading, color: _vm.loadingColor },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading
            ? _c("div", [
                _vm.records.length
                  ? _c("table", { staticClass: "table table-sm table-hover" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v("№")]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              class: {
                                pointer: true,
                                sorted: _vm.sortingField.pass_date,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.updateSorting("pass_date")
                                },
                              },
                            },
                            [
                              _vm._v("\n              Дата "),
                              _c("i", {
                                staticClass: "icon-fa icon-fa-sort-amount-desc",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", [_vm._v("Подотчетное лицо")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Склад")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Тип расхода")]),
                          _vm._v(" "),
                          _c("th"),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              class: {
                                pointer: true,
                                sorted: _vm.sortingField.sum,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.updateSorting("sum")
                                },
                              },
                            },
                            [
                              _vm._v("Сумма "),
                              _c("i", {
                                staticClass: "icon-fa icon-fa-sort-amount-desc",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", [_vm._v("Валюта")]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              class: {
                                pointer: true,
                                sorted: _vm.sortingField.grouped_sum,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.updateSorting("grouped_sum")
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$AllCurrencies[_vm.resultCurrency]
                                    .currency
                                ) + " "
                              ),
                              _c("i", {
                                staticClass: "icon-fa icon-fa-sort-amount-desc",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", [_vm._v("Комментарий")]),
                          _vm._v(" "),
                          _c("th"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.records, function (record, index) {
                          return _c("tr", { key: index }, [
                            _c("td", [
                              _vm._v(
                                _vm._s(index + 1) +
                                  " (" +
                                  _vm._s(record.id) +
                                  ")"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.moment(record.pass_date, "DD.MM.YYYY")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  record.division_id === 0 ||
                                    !record.division_id
                                    ? "Администрация"
                                    : record?.user?.short_name
                                ) + "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  record.to_division_id === 0 ||
                                    !record.division_id
                                    ? "Администрация"
                                    : (_vm.$AllDivisions[
                                        record.to_division_id
                                      ] &&
                                        _vm.$AllStores[
                                          _vm.$AllDivisions[
                                            record.to_division_id
                                          ].stores[0]?.object_id
                                        ]?.short_title) ||
                                        record.to_division_id
                                ) + "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.allExpensesTypes[record.type_id])
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(record.card?.number))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(record.sum))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.$AllCurrencies[record.currency_id]
                                    .currency
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(record.grouped_sum))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(record.comment))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  record.affect_saldo
                                    ? null
                                    : "не влияет на прибыль"
                                )
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }